import { Empty } from 'antd'
import { TableLocale } from 'antd/es/table/interface'
import React from 'react'
import { useIntl } from '@/i18n/hooks/use-intl'

/**
 * @description The basic table locale that contains the localized empty description.
 */
const useTableLocale = (): TableLocale => {
  const { formatMessage } = useIntl()

  return {
    emptyText: (
      <Empty
        description={formatMessage({ id: 'autoreport:chart_label_empty_data' })}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    ),
    filterConfirm: formatMessage({ id: 'general:btn_text_confirm' }),
    filterReset: formatMessage({ id: 'search:filter_reset_button' }),
  }
}

export default useTableLocale
